/**
 * Chat / credentials / setup ใช้ product (project) UUID ต่อ service
 * ตั้งค่า mapping ที่นี่เมื่อมี service ใหม่
 */
export const DEFAULT_PRODUCT_ID = "bd0be8d0-b184-4657-a44e-82a8d1d3ce78";

const SERVICE_TO_PRODUCT: Record<string, string> = {
  cmjcrj5ad000gg8xz8icco4jr: "938d98a0-1e1c-414f-aa77-2507358ff9f1",
};

export function getProductIdForService(
  serviceId: string | null | undefined,
): string {
  if (!serviceId) return DEFAULT_PRODUCT_ID;
  return SERVICE_TO_PRODUCT[serviceId] ?? DEFAULT_PRODUCT_ID;
}
